import { createPopper } from '@popperjs/core'

const showEvents = ['mouseenter', 'focus']
const hideEvents = ['mouseleave']

document.querySelectorAll('a').forEach((button) => {
  const href = button.getAttribute('href')
  if (href)
    if (href.indexOf('products') > -1) {
      const productHandle = button
        .getAttribute('href')
        .split('/products/')[1]
        .replace('/', '')
      const tooltip = document.getElementById(productHandle)
      if (tooltip) {
        let toolTipItemFocused = false
        let popperInstance = null

        function show() {
          tooltip.setAttribute('data-show', '')
          popperInstance.update()
          popperInstance.state.elements.popper
            .querySelectorAll('img')
            .forEach((image) => {
              image.src = image.dataset.src
            })
        }

        function hide() {
          tooltip.removeAttribute('data-show')
        }

        showEvents.forEach((event) => {
          button.addEventListener(event, show)
        })

        hideEvents.forEach((event) => {
          button.addEventListener(event, () => {
            window.requestAnimationFrame(() => {
              if (
                !tooltip.classList.contains('tooltip--hovered') ||
                toolTipItemFocused
              ) {
                hide()
              }
            })
          })
        })

        button.addEventListener('blur', () => {
          window.requestAnimationFrame(() => {
            if (!toolTipItemFocused) {
              hide()
            }
          })
        })

        // Pass the button, the tooltip, and some options, and Popper will do the
        // magic positioning for you:
        popperInstance = createPopper(button, tooltip, {
          placement: 'top',
        })

        // check if tooltip is hovered

        tooltip.addEventListener('mouseenter', () => {
          tooltip.classList.add('tooltip--hovered')
        })

        tooltip.addEventListener('mouseleave', () => {
          tooltip.classList.remove('tooltip--hovered')
          hide()
        })

        // tooltip focus out

        let tooltipTabbableItems = tooltip.querySelectorAll([
          'input',
          'select',
          'a[href]',
          'textarea',
          'button',
          '[tabindex]',
        ])

        tooltipTabbableItems.forEach((item) => {
          item.addEventListener('focus', () => {
            item === document.activeElement
              ? (toolTipItemFocused = true)
              : (toolTipItemFocused = false)
          })

          item.addEventListener('blur', () => {
            tooltipTabbableItems.forEach((item) => {
              item === document.activeElement
                ? (toolTipItemFocused = true)
                : (toolTipItemFocused = false)
            })

            window.requestAnimationFrame(() => {
              if (!toolTipItemFocused) {
                hide()
              }
            })
          })
        })
      }
    }
})
